<template>
  <main class="reward container" v-if="reward">
    <div class="row">
      <div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">{{ $t("Catalogo") }}</li>
            <li class="breadcrumb-item active text-primary" aria-current="page">
              {{ reward.title }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-7">
        <div class="image-container">
          <img
            :src="(reward.image.includes('http') ? '' : '/') + reward.image"
            :alt="reward.title"
            class="img-fluid"
          />
        </div>
      </div>
      <div class="col-12 col-md-5 pt-md-4 pl-md-5">
        <template v-if="reward.type === 'coins'">
          <h5 class="text-primary text-uppercase text-left" v-cloak>
            {{ reward.cost }} {{ $t("Coins") }}
            <br />
            <small calss="text-muted" style="font-size:60%;color:#989898">
              <span>
                <template
                  v-if="
                    parseInt(reward.max_requests) -
                      parseInt(reward.user_redeems) >
                      1
                  "
                >
                  {{ $t("Richiedibile") }}
                  <strong
                    >{{
                      parseInt(reward.max_requests) -
                        parseInt(reward.user_redeems)
                    }}
                    {{ $t("volte") }}</strong
                  >
                </template>
              </span>
            </small>
          </h5>
        </template>
        <template v-else>
          <h5 class="text-primary text-uppercase text-left" v-cloak>
            {{ reward.cost }} EXP
            <br />
            <small calss="text-muted" style="font-size:60%;color:#989898">
              <span>
                <template
                  v-if="
                    parseInt(reward.max_requests) -
                      parseInt(reward.user_redeems) >
                      1
                  "
                >
                  {{ $t("Richiedibile") }}
                  <strong
                    >{{
                      parseInt(reward.max_requests) -
                        parseInt(reward.user_redeems)
                    }}
                    {{ $t("volte") }}
                  </strong>
                </template>
              </span>
            </small>
          </h5>
        </template>
        <h4 class="text-left">{{ reward.title }}</h4>
        <p id="description-reward">{{ reward.description }}</p>
        <template v-if="reward.max_requests <= reward.user_redeems">
          <div class="text-center text-md-left">
            <div
              class="btn btn-grey text-uppercase btn-lg"
              style="display: inline-block;cursor:initial;background-color: #21252908;"
            >
              <template v-if="reward.type === 'coins'">{{
                $t("Già richiesto")
              }}</template>
              <template v-else>{{ $t("Già sbloccato") }}</template>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="text-center text-md-left redeem">
            <template
              v-if="differenceBetweenRewardCurrencyAndUserCurrency(reward) <= 0"
            >
              <button
                class="btn btn-lg btn-primary text-uppercase"
                @click="requestReward(reward)"
              >
                <template v-if="reward.type === 'coins'">{{
                  $t("Richiedi")
                }}</template>
                <template v-else>{{ $t("Sblocca") }}</template>
              </button>
            </template>
            <template v-else>
              <div class="text-center text-md-left">
                {{ $t("Ti mancano") }}
                <b>{{
                  differenceBetweenRewardCurrencyAndUserCurrency(reward)
                }}</b>
                <template v-if="reward.type === 'coins'">
                  <b> {{ $t("coins") }}</b>
                  {{ $t("per ottenerlo") }}
                </template>
                <template v-else>
                  <b> {{ $t("Exp") }}</b>
                  {{ $t("per sbloccarlo") }}
                </template>
                <br />
                <button
                  @click="$router.push('/actions')"
                  class="text-upPpercase btn btn-lg btn-primary mt-2"
                >
                  {{ $t("Fai più azioni") }}
                </button>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import _ from "lodash";
export default {
  name: "reward",
  props: {
    rewardProp: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      reward: null
    };
  },
  async created() {
    this.reward = this.rewardProp;
    if (this.reward == null && _.get(this.$route, "query.rewardId", false)) {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/catalog/rewards/" +
            this.$route.query.rewardId
        );
        this.reward = _.get(response, "data.data");
      } catch (e) {
        console.log(e);
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }
      this.$store.commit("hideSpinner");
    }
  },
  methods: {
    differenceBetweenRewardCurrencyAndUserCurrency(reward) {
      if (reward.type === "coins") {
        return reward.cost - this.$store.getters.getUserCoins;
      }

      return reward.cost - this.$store.getters.getUserPoints;
    },
    async requestReward(reward) {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.get(
          "api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/catalog/rewards/" +
            reward.id +
            "/request"
        );

        this.$router.push("/catalog");
        this.$store.dispatch("getUserInfo");
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "error",
          title: "Error",
          text: "An error occurred"
        });
      }

      this.$store.commit("hideSpinner");
    }
  }
};
</script>

<style scoped>
.breadcrumb {
  background: transparent;
  padding: 0.75rem 0;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: "|";
}
.image-container {
  width: 100%;
  height: 459px;
  border-radius: 5px;
  box-shadow: 20px 20px 40px 0 rgba(2, 8, 22, 0.1);
  background-color: #e2e6e7;
  border: solid 1px #f1f1f1;
  overflow: hidden;
  position: relative;
  text-align: center;
  line-height: 455px;
  margin-bottom: 20px;
}
.image-container img {
  max-height: 100%;
  max-width: 100%;
}
p {
  margin-top: 48px;
  margin-bottom: 39px;
}
.redeem .btn {
  font-weight: bold;
}
.no-redeem {
  background-color: #21252908;
  padding: 5px;
  border-radius: 0.25rem;
}
@media (max-width: 768px) {
  .redeem .btn {
    width: 100%;
  }
}
#description-reward {
  white-space: pre-wrap;
}
</style>
